// extracted by mini-css-extract-plugin
export default {"testimonials":"styles_testimonials__ofwvC","testimonials_item":"styles_testimonials_item__ODKOU","testimonials_toutch":"styles_testimonials_toutch__lzfZD"};